import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Alert, Button, Card, Form, Popover, Select, Table, TableColumnsType, Tag, UploadFile} from "antd";
import Colors from "../../../styles/Colors";
import {BiDownload, BiFilter, BiMessage, BiRefresh, BiSearch} from "react-icons/bi";
import Historials from "../../components/Historials";
import {TableProps} from "antd/es/table";
import {BsFilePdf, BsPerson} from "react-icons/bs";
import toast, {Toaster} from "react-hot-toast";
import InscripcioFiltre from "../../../model/multilleure/casals/InscripcioFiltre";
import Activitat from "../../../model/inscripcions/Activitat";
import {GetActivitats} from "../../../dao/multilleure/GetActivitats";
import {GetInscripcionsActivitatsIdFiltres} from "../../../dao/multilleure/casals/GetInscripcionsActivitatsIdFiltres";
import {GetLlistats} from "../../../dao/multilleure/casals/GetLlistats";
import {PostInscripcionsAlumneCasalFiltrat} from "../../../dao/multilleure/casals/PostInscripcionsAlumneCasalFiltrat";
import {PostLlistatAlumneCasalPdf} from "../../../dao/multilleure/casals/PostLlistatAlumneCasalPdf";
import ContactesModal from "./components/ContactesModal";
import DocumentacioModal from "../../inscripcions/components/DocumentacioModal";
import {GetInscripcionsIdAlumneIdDocuments} from "../../../dao/inscripcions/GetInscripcionsIdAlumneIdDocuments";

const AlumneCasal = () => {
    const titol: string = "ALUMNES CASAL";
    const nomPermis: string = "Alumne Casal";

    const {isLoggedIn, userId, user, page, token} = useContext(AuthContext);
    const {id} = useParams();
    const [idActivitat, setIdActivitat] = useState("0");

    const [showFilters, setShowFilters] = useState(false);
    const [showFiltersButton, setShowFiltersButton] = useState(false);
    const [coleccio, setDades] = useState<any[]>([])
    const [activitats, setActivitats] = useState<Activitat[]>([]);

    const [showDocu, setShowDocu] = useState(false);
    const [showDocuEle, setShowDocuEle] = useState<any>();
    const [elementSelected, setElementSelected] = useState<any>();
    const [docs, setDocs] = useState<UploadFile[]>([]);

    const [loading, setLoading] = useState(false);
    const [selectedCasal, setSelectedCasal] = useState(false);
    const [visible, setVisible] = useState(true);

    const permisosEdicio = user.pagines.some(pagina => {
        return pagina.descripcio === nomPermis && pagina.tipus === 1
    });

    const [contactesModal, setContactesModal] = useState(false);
    const [documentacioModal, setDocumentacioModal] = useState(false);

    const [filtres, setFiltres] = useState<InscripcioFiltre>(new InscripcioFiltre());

    const [filtreCasal, setFiltreCasal] = useState<any>([]);
    const [filtreCampus, setFiltreCampus] = useState<any>([]);
    const [filtreOpcio, setFiltreOpcio] = useState<any>([]);

    const [descarregar, setDescarregar] = useState<any>(false);
    const [llistats, setLlistats] = useState<[]>([]);
    const [llistaActivitats, setLlistaActivitats] = useState<Activitat[]>([]);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);

    const [documentUrlPdf, setDocumentUrlPdf] = useState<string | undefined>("");
    const [selected, setSelected] = useState<boolean>(false);

    const [form] = Form.useForm();

    useEffect(() => {
        if (isLoggedIn) {
            getActivitats();
        }
    }, [id]);


    async function showContactes(element: any, edit: boolean) {
        setContactesModal(true);
        setElementSelected(element);
    }

    async function handleSubmit() {
        handleLoadingChange(true)
        const formData = form.getFieldsValue();
        //console.log("Form Data:", formData);
        //console.log(JSON.stringify(formData));

        const dad = await PostInscripcionsAlumneCasalFiltrat(formData, page);
        setDades(dad);
        setNameFilters(dad)
        handleLoadingChange(false);
    }

    function setNameFilters(elements: any[]) {
        console.log(elements);
        const ingredientNames = elements?.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        console.log(JSON.stringify(ingredientNames));
        setNomFiltres(ingredientNames);
    } 


    async function getActivitats() {
        const act: Activitat[] = await GetActivitats(page);
        setLlistaActivitats(act);
        const llistes = await GetLlistats(nomPermis, page);
        setLlistats(llistes);
        if (act.length === 1) {
            handleLoadingChange(true);
            setIdActivitat(act[0].id + "");
            //console.log(act[0].id);
            const newFiltres = {...filtres, activitat: act[0].id};
            setFiltres(newFiltres);
            //const dades = await PostInscripcionsAlumneCasalFiltrat(newFiltres, page);
            const fil = await GetInscripcionsActivitatsIdFiltres(token, act[0].id + "", page);
            updateFiltres(fil);
            //setDades(dades);
            //setNameFilters(dades);
            setDescarregar(true);
            handleLoadingChange(false);
        }
        setActivitats(act);
        setShowFilters(true);
        setShowFiltersButton(true);
        setSelected(true);
    }

    async function checkDades(id_activitat: string) {
        setShowFiltersButton(false);
        setShowFilters(false);
        setDescarregar(false);
        if (id_activitat !== "0") {
            handleLoadingChange(true)
            setIdActivitat(id_activitat);
            const fil = await GetInscripcionsActivitatsIdFiltres(token, id_activitat, page);
            updateFiltres(fil);
            setDescarregar(true);
            handleLoadingChange(false);
        }
        setShowFilters(true);
        setShowFiltersButton(true);
    }

    function updateFiltres(json: any) {

        console.log(permisosEdicio);
        if (permisosEdicio) {
            setFiltreCasal(json.casals);
        } else {
            console.log(JSON.stringify(json.casals));
            const casalsFiltrats = json.casals.filter((casal: any) => casal.value !== "TOT");
            setFiltreCasal(casalsFiltrats);
            console.log(JSON.stringify(casalsFiltrats));
        }

    }

    function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setDocumentacioModal(false);
        setContactesModal(false);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };


    const tableProps: TableProps<any> = {
        loading
    };

    function changeActivitat(id_activitat: string) {
        setIdActivitat(id_activitat);
        setSelected(true);
        checkDades(id_activitat);
    }

    async function showDocuments(ele: any, b: boolean) {
        const dds3 = await GetInscripcionsIdAlumneIdDocuments(ele.id + "", ele.id_alumne_casal + "", page);
        setDocs(dds3.fileList);
        setShowDocuEle(ele);
        setDocumentacioModal(true);
    }
    const colorsArray = [Colors.colors.color1, Colors.colors.color2, Colors.colors.color4, Colors.colors.color5, Colors.colors.color6];

    const columns: TableColumnsType<any> = [
        {
            key: 'key',
            title: 'ID',
            dataIndex: 'key',
            width: 30
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.includes(value) : false),
            render: (infant, ele) => (
                <Popover content={(
                    <div>
                        <p>{ele.comentaris}</p>
                        <p>{ele.observacions}</p>
                    </div>
                )}
                         title="Comentaris" trigger="click">
                    <Tag key={ele.key}
                         color={ele.comentaris !== '' || ele.observacions !== '' ? Colors.colors.color1 : Colors.colors.color5}>
                        {ele.nom}&nbsp;{(ele.comentaris !== '' || ele.observacions !== '') && <BiMessage/>}
                    </Tag>
                </Popover>
            )
        },
        {
            key: 'casal',
            title: 'Casal',
            dataIndex: 'casal',
            width: 100,
        },
        {
            key: 'campus',
            title: 'Campus',
            dataIndex: 'campus',
            width: 30,
        },
        {
            key: 'curs',
            title: 'Curs',
            dataIndex: 'curs',
            width: 30,
            render: (estat, ele) => (
                <>
                    <Tag color={Colors.colors.color3} key={ele.key}>{ele.cicle}</Tag>
                    <Tag color={Colors.colors.color4} key={ele.key}>{ele.curs}</Tag>
                </>
            )
        },
        {
            key: 'setmanes',
            title: 'Setmanes',
            dataIndex: 'setmanes',
            width: 30,
            render: (estat, ele) => (
                ele.configuracions.map((elemento: any, index: number) => (
                    <div key={index}>
                        {elemento.setmanesNumeros.map((setmana: any, idx: number) => (
                            <Tag color={colorsArray[index % colorsArray.length]} key={idx}>
                                {setmana} - {elemento.nom_torn}
                            </Tag>
                        ))}
                    </div>
                ))
            )
        },
        {
            key: 'dies',
            title: 'Dies',
            dataIndex: 'dies',
            width: 30,
            render: (estat, ele) => (
                ele.configuracions.map((elemento: any, index: number) => (
                    <div key={index}>
                        {elemento.diesNumeros.map((setmana: any, idx: number) => (
                            <Tag color={colorsArray[index % colorsArray.length]} key={idx}>
                                {setmana} - {elemento.nom_torn}
                            </Tag>
                        ))}
                    </div>
                ))
            )
        },
        {
            key: 'alergensNoms',
            title: 'Al·lergens',
            dataIndex: 'alergensNoms',
            width: 30
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 150,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Contactes"} style={{backgroundColor: Colors.colors.color5}}
                                    onClick={() => showContactes(ele, false)}><BsPerson/></Button>
                            {" "}
                            <Button title={"Mostrar Documents"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => showDocuments(ele, true)}><BsFilePdf/></Button>
                        </>
                    )}
                </>
            )
        }
    ];

    const setmanes = [
        {value: "0", label: "TOTES"},
        {value: "1", label: "Setmana-1"},
        {value: "2", label: "Setmana-2"},
        {value: "3", label: "Setmana-3"},
        {value: "4", label: "Setmana-4"},
        {value: "5", label: "Setmana-5"},
        {value: "6", label: "Setmana-6"},
    ];

    function changeCasal(element: any) {
        const selectedCasal = filtreCasal.find((casal: any) => casal.value === element);

        setFiltreCampus(selectedCasal.campus);
        setFiltreOpcio(selectedCasal.opcions);
        const newFiltres = {...filtres, idCampus: 0, idOpcio: 0}
        setFiltres(newFiltres);
        setSelectedCasal(true);
    }

    async function download() {

        const formData = form.getFieldsValue();
        console.log("Form Data:", formData);
        //console.log(JSON.stringify(formData));

        const documentUrl = await PostLlistatAlumneCasalPdf(formData, page);
        setDocumentUrlPdf(documentUrl);

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `Llistat.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades(idActivitat)}><BiRefresh/></Button>
                            <Button title={"Mostrar filtres"} style={{backgroundColor: Colors.colors.color5}}
                                    disabled={!showFiltersButton}
                                    onClick={() =>
                                        setShowFilters(!showFilters)}><BiFilter/></Button>
                        </div>
                        {showFilters && (
                            <>
                                <br/>
                                <br/>
                                <br/>
                                <Form form={form} initialValues={filtres} onFinish={handleSubmit}>
                                    <Form.Item style={{marginBottom: 0}}>
                                        <Form.Item
                                            name="activitat"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={activitats.length === 0}
                                                    placeholder="Selecciona Activitat"
                                                    optionFilterProp="children"
                                                    onChange={changeActivitat}
                                                    options={activitats}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name="idCasal"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={filtreCasal?.length < 0 || !selected}
                                                    placeholder="Selecciona Casal"
                                                    optionFilterProp="children"
                                                    onChange={changeCasal}
                                                    options={filtreCasal}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name="idCampus"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={filtreCampus.length < 0 || !selected || !selectedCasal}
                                                    placeholder="Selecciona Campus"
                                                    optionFilterProp="children"
                                                    options={filtreCampus}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name="idOpcio"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={filtreOpcio.length < 0 || !selected || !selectedCasal}
                                                    placeholder="Selecciona Opció"
                                                    optionFilterProp="children"
                                                    options={filtreOpcio}
                                            />
                                        </Form.Item>
                                        <br/>
                                        <br/>
                                        <Form.Item
                                            name="setmana"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                        >
                                            <Select showSearch
                                                    disabled={filtreCasal.length < 0 || !selected || !selectedCasal}
                                                    placeholder="Selecciona Setmana"
                                                    optionFilterProp="children"
                                                    options={setmanes}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}>
                                            <Button title={"Buscar"} htmlType={"submit"} disabled={!selectedCasal}
                                                    style={{backgroundColor: Colors.colors.color6}}><BiSearch/></Button>
                                            {" "}
                                            <Button title={"Descarregar dades"} onClick={download}
                                                    disabled={!selectedCasal}
                                                    style={{backgroundColor: Colors.colors.color3}}><BiDownload/></Button>
                                        </Form.Item>
                                        <Form.Item
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}>
                                        </Form.Item>
                                    </Form.Item>
                                </Form>
                                <br/>
                            </>
                        )}
                        <h4 className={"titol"}>{titol}</h4>
                        {visible && (
                            <>
                                <p>Número d'alumnes: <b>{coleccio ? coleccio.length : 0}</b></p>
                                <Alert type={"info"}
                                       message={"Pots veure els comentaris fent `click` al nom de l'infant. El infants amb comentaris estan de color més fosc!"}/>
                                <Alert type={"warning"}
                                       message={"Si no et surten casals al llistat pot ser perquè la teva sessió estigui caducada o oberta en un altre dispositiu. Torna a iniciar sessió!"}/>
                                <Table
                                    {...tableProps}
                                    columns={columns}
                                    dataSource={coleccio}
                                />
                            </>
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={titol} pagina={page}/>
                    {contactesModal && (
                        <ContactesModal element={elementSelected} onClose={handleCloseModal} visible={contactesModal} editar={false} idInsc={''}/>
                    )}
                    {documentacioModal && (
                        <DocumentacioModal element={showDocuEle} visible={documentacioModal} page={page}
                                           onClose={handleCloseModal} documents={docs}
                                           idInsc={showDocuEle.id_inscripcio}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default AlumneCasal;
